// @ts-nocheck

class SignUpOb1 extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.submitBtn = null;
    this.successEl = null;
  }

  connectedCallback() {
    this.form = this.querySelector('.signup-ob1__form');
    this.submitBtn = this.querySelector('.signup-ob1__submit');
    this.successEl = this.querySelector('.signup-ob1__success');
    if (this.form) this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    this.maybeShowSuccessOnLoad();
  }

  // If someone reloads, bookmarks, or shares the "-thank-you" URL left behind by
  // updateUrlForThankyou(), show the success state immediately instead of the form.
  maybeShowSuccessOnLoad() {
    if (window.location.pathname.endsWith('-thank-you')) {
      this.showSuccess(false);
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if (!this.validateForm()) return;

    const payload = this.buildPayload();
    this.setSubmitting(true);
    this.postToSheet(payload)
      .then(() => this.showSuccess())
      .catch((err) => console.warn('[sign-up-ob1] submission failed:', err))
      .finally(() => this.setSubmitting(false));
  }

  validateForm() {
    if (!this.form) return false;
    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return false;
    }
    return true;
  }

  buildPayload() {
    return {
      name: (this.form.elements.name?.value || '').trim(),
      email: (this.form.elements.email?.value || '').trim().toLowerCase(),
      tab: this.dataset.sheetTab || '',
      page_url: window.location.href,
    };
  }

  async postToSheet(data) {
    const sheetUrl = this.dataset.sheetUrl || '';
    if (!sheetUrl) return;

    const formData = new FormData();
    Object.keys(data).forEach((key) => formData.append(key, data[key]));

    await fetch(sheetUrl, {
      method: 'POST',
      mode: 'no-cors',
      body: formData,
    });
  }

  setSubmitting(isSubmitting) {
    if (!this.submitBtn) return;
    if (isSubmitting) {
      this.submitBtn.setAttribute('disabled', 'true');
      this.submitBtn.classList.add('is-loading');
    } else {
      this.submitBtn.removeAttribute('disabled');
      this.submitBtn.classList.remove('is-loading');
    }
  }

  showSuccess(updateUrl = true) {
    if (this.form) this.form.classList.add('signup-ob1__hidden');
    if (this.successEl) this.successEl.classList.remove('signup-ob1__hidden');
    if (updateUrl) this.updateUrlForThankyou();
  }

  // Leaves the page's own content untouched and just rewrites the visible URL to end
  // in "-thank-you", mirroring the waitlist flow's URL. This is client-side only (History
  // API) — reloading or sharing that URL will 404 unless a matching Shopify page with the
  // "-thank-you" handle actually exists.
  updateUrlForThankyou() {
    try {
      const url = new URL(window.location.href);
      const pathname = url.pathname.replace(/\/$/, '');
      if (!pathname.endsWith('-thank-you')) {
        url.pathname = `${pathname}-thank-you`;
        window.history.replaceState({}, '', url.toString());
      }
    } catch (err) {
      console.warn('[sign-up-ob1] URL update failed:', err);
    }
  }
}

if (!customElements.get('sign-up-ob1')) {
  customElements.define('sign-up-ob1', SignUpOb1);
}
